import React, { useCallback } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IOffer } from '@rbi-ctg/menu';
import { IOfferFeedbackEntryFragment } from 'generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useOffer } from '../use-offer';

import { CellLayout } from './cell-layout';

interface IOfferCellProps extends IBaseProps {
  offer: IOffer;
  offerFeedback: IOfferFeedbackEntryFragment | null;
  onPress: (offerId: string) => void;
  isSelected: boolean;
}

export const OfferCell: React.FC<React.PropsWithChildren<IOfferCellProps>> = ({
  offer,
  offerFeedback,
  onPress,
  isSelected,
}) => {
  const { endingIn, platforms, displayLoginRequiredBadge } = useOffer({
    offer,
    offerFeedback,
  });
  const onPressOffer = useCallback(() => onPress(offer._id), [offer, onPress]);
  const enableOfferBadges = useFlag(LaunchDarklyFlag.ENABLE_OFFER_BADGES);

  return (
    <CellLayout
      offer={offer}
      onPress={onPressOffer}
      isSelected={isSelected}
      redeemable
      enableOfferBadges={enableOfferBadges}
      endingIn={endingIn}
      platforms={platforms}
      displayLoginRequiredBadge={displayLoginRequiredBadge}
    />
  );
};
